import LandingFaqsSection from './LandingFaqsSection';

export default LandingFaqsSection;
